import Api from '@/services/Api'

export default {
    createMapeoBalance (form) {
      return Api().post('mapeo-balance/create', form)
    },
    getAllMapeoBalance(){
        return Api().get('mapeo-balance')
    }
  }
  